import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { updatedResponse } from '../../routes/defaultResponses';
import { makeStringEnum } from '../../utils/typeboxHelpers';

const optionalScoreSchema = Type.Optional(makeStringEnum(['A', 'B', 'C', 'D', 'E', 'F', 'G']));

export const rovLabelPaths = {
    '/api/surveys/{surveyId}/inspectionStandardData/rovLabel': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'rovLabelControllers.getData',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                locatie: Type.Optional(Type.String()),
                                naam: Type.Optional(Type.String()),
                                omschrijving: Type.Optional(Type.String()),
                                reguliereInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                                reguliereInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                                reguliereInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                                reguliereInspectieKosten: Type.Optional(Type.Number()),
                                reguliereInspectieKostenRovLabelScore: optionalScoreSchema,
                                reguliereInspectieMilieuRovLabelScore: optionalScoreSchema,
                                reguliereInspectieOverallRovLabelScore: optionalScoreSchema,
                                reguliereInspectieRendementRovLabelScore: optionalScoreSchema,
                                reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                                reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                                reguliereInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                                reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                                reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                                reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                                rovInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                                rovInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                                rovInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                                rovInspectieKosten: Type.Optional(Type.Number()),
                                rovInspectieKostenRovLabelScore: optionalScoreSchema,
                                rovInspectieMilieuRovLabelScore: optionalScoreSchema,
                                rovInspectieOverallRovLabelScore: optionalScoreSchema,
                                rovInspectieRendementRovLabelScore: optionalScoreSchema,
                                rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                                rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                                rovInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                                rovInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                                rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                                rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            locatie: Type.Optional(Type.String()),
                            naam: Type.Optional(Type.String()),
                            omschrijving: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                            reguliereInspectieKosten: Type.Optional(Type.Number()),
                            reguliereInspectieKostenRovLabelScore: optionalScoreSchema,
                            reguliereInspectieMilieuRovLabelScore: optionalScoreSchema,
                            reguliereInspectieOverallRovLabelScore: optionalScoreSchema,
                            reguliereInspectieRendementRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                            reguliereInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                            reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                            rovInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                            rovInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                            rovInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                            rovInspectieKosten: Type.Optional(Type.Number()),
                            rovInspectieKostenRovLabelScore: optionalScoreSchema,
                            rovInspectieMilieuRovLabelScore: optionalScoreSchema,
                            rovInspectieOverallRovLabelScore: optionalScoreSchema,
                            rovInspectieRendementRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                            rovInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                            rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                        }),
                    },
                },
            },
        },
        post: {
            operationId: 'rovLabelControllers.update',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            locatie: Type.Optional(Type.String()),
                            naam: Type.Optional(Type.String()),
                            omschrijving: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                            reguliereInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                            reguliereInspectieKosten: Type.Optional(Type.Number()),
                            reguliereInspectieKostenRovLabelScore: optionalScoreSchema,
                            reguliereInspectieMilieuRovLabelScore: optionalScoreSchema,
                            reguliereInspectieOverallRovLabelScore: optionalScoreSchema,
                            reguliereInspectieRendementRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                            reguliereInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                            reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                            reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                            rovInspectieDeHinderVoorHetWegverkeerCategorie: Type.Optional(Type.String()),
                            rovInspectieDeHinderVoorHetWegverkeerKlasse: Type.Optional(Type.String()),
                            rovInspectieDeHinderVoorHetWegverkeerRovLabelScore: optionalScoreSchema,
                            rovInspectieKosten: Type.Optional(Type.Number()),
                            rovInspectieKostenRovLabelScore: optionalScoreSchema,
                            rovInspectieMilieuRovLabelScore: optionalScoreSchema,
                            rovInspectieOverallRovLabelScore: optionalScoreSchema,
                            rovInspectieRendementRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore: Type.Optional(Type.Number()),
                            rovInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVanHetObjectScore: Type.Optional(Type.Number()),
                            rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore: optionalScoreSchema,
                            rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore: Type.Optional(Type.Number()),
                        }),
                    },
                },
            },
            responses: {
                ...updatedResponse,
            },
        },
    },
} as const;
